import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ErrorModel} from '../app.model';
import {ACTION_TYPES} from '../app.types';
import {AppStore} from '../store/store';
import {HttpClientUtils} from '../utils/http-client.utils';
import {HttpInteraction} from '../utils/http-interactions.utils';
import {PartnerModel} from './partner.model';

export interface PartnerAction {
  type: string;
  partners?: PartnerModel[];
  error?: ErrorModel;
}

@Injectable()
export class PartnerService {

  private static PARTNER_ALL = {id: -1, name: 'All Partners', abbreviation: ''};

  constructor(public appStore: AppStore, private http: HttpClientUtils) {
  }

  getPartnerList(): void {
    this.http.getForJson(`${environment.apiSegments}/partners`, {})
      .onSuccess((response: any) => {
        const partners = response;
        partners?.push(PartnerService.PARTNER_ALL);

        this.appStore.dispatch({type: ACTION_TYPES.PARTNER_LIST_GET, partners});
      })
      .onError((error) => {
        this.appStore.dispatch({type: ACTION_TYPES.PARTNER_LIST_GET_ERROR, error: HttpInteraction.errorModel(error)});
      })
      .doIt();
  }
}
